import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import {
  ManagerFiltersActionTypes,
  ManagerSetAllDefaultFilters
} from './actions';
import { ManagerActionTypes } from '../manager/actions';
import {
  selectManagerFiltersUnsavedDefaultsState,
  SharedState
} from '../reducer';

@Injectable()
export class ManagerFilterEffects {
  public STORAGE_KEY = 'manager-default-selection-state';

  
  public loadManagerDefaultSelectionFilterState$: Observable<ManagerSetAllDefaultFilters> = createEffect(() => this.actions$
    .pipe(ofType(ManagerActionTypes.LoadManager))
    .pipe(
      map(() => {
        const state = JSON.parse(localStorage.getItem(this.STORAGE_KEY));
        return new ManagerSetAllDefaultFilters(state);
      })
    ));

  
  public saveManagerDefaultSelectionFilterState$: Observable<void> = createEffect(() => this.actions$
    .pipe(
      ofType(ManagerFiltersActionTypes.SetAllUnsavedAsDefault),
      withLatestFrom(
        this.store.pipe(select(selectManagerFiltersUnsavedDefaultsState))
      )
    )
    .pipe(
      map(([, filters]) => {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(filters));
      })
    ), { dispatch: false });

  constructor(private actions$: Actions, private store: Store<SharedState>) {}
}
